import { Set } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { BottomModal } from '../../../components/Modal';
import styles from './filter.scss';

const propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  filterTags: PropTypes.instanceOf(Set),
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

const Filter = ({
  tags,
  filterTags,
  onOpen,
  onClose,
  onToggle,
  isOpen,
}) => (
  <>
    <div
      onClick={onOpen}
      role="button"
      tabIndex="0"
      className={classNames(
        styles.filter,
        { [styles.filterActive]: filterTags.size > 0 },
      )}
    >
      <i className="far fa-sliders-h" />
      {' '}
      Filter
    </div>
    <BottomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      buttonText="Done"
    >
      { /* TODO: EMPTY MESSAGE */ }
      <div className={styles.tags}>
        { tags && tags.map((tag) => (
          <div
            key={tag.id}
            onClick={onToggle(tag.id)}
            role="button"
            tabIndex="0"
            className={classNames(
              styles.tag,
              { [`${styles.active}`]: filterTags.has(tag.id) },
            )}
          >
            {tag.name}
          </div>
        ))}
      </div>
    </BottomModal>
  </>
);

Filter.propTypes = propTypes;

export default Filter;
